import { JSX, ReactNode, createContext, useContext, useState } from 'react';

type AccountInfoCtx = {
  currency: string;
  accountNumber: string;
  token: string;
  setNewCurrencyInfo: (newCurrency: string) => void;
  setNewAccountNumber: (newAccountNumber: string) => void;
  setNewToken: (newToken: string) => void;
};

export const AccountInfoContext = createContext<AccountInfoCtx>({
  currency: '',
  accountNumber: '',
  token: '',
  setNewCurrencyInfo: () => {},
  setNewAccountNumber: () => {},
  setNewToken: () => {},
});

export const AccountInfoProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const [currency, setCurrency] = useState<string>('CAD');
  const [accountNumber, setAccountNumber] = useState<string>('');
  const [token, setToken] = useState<string>('');

  const handleNewCurrencyInfo = (newCurrency: string) => {
    setCurrency(newCurrency);
  };

  const handleNewAccountNumber = (newAccountNumber: string) => {
    setAccountNumber(newAccountNumber);
  };

  const handleNewToken = (newToken: string) => {
    setToken(newToken);
  };

  return (
    <AccountInfoContext.Provider
      value={{
        currency,
        accountNumber,
        token,
        setNewCurrencyInfo: handleNewCurrencyInfo,
        setNewAccountNumber: handleNewAccountNumber,
        setNewToken: handleNewToken,
      }}
    >
      {children}
    </AccountInfoContext.Provider>
  );
};

export const useAccountInfo = (): AccountInfoCtx => useContext(AccountInfoContext);
